import { Component, Input, OnInit } from '@angular/core';
import { NgbAccordionModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import {
	VideoArticle,
	AudioArticle,
	ImageArticle,
	TranscriptionItem,
} from '@meta-press/shared-plugins';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { TranscriptionVerbose } from 'openai/resources/audio/transcriptions.mjs';
import { Article } from '@meta-press/shared-plugins';

import { SourceMaterialService } from '../source-material-service/source-material.service';
import { Observable } from 'rxjs';
import { OpenAIService } from '../services/openai-service';

@Component({
	selector: 'app-media-viewer',
	standalone: true,
	imports: [CommonModule, SafeUrlPipe, NgbAccordionModule],
	templateUrl: './media-viewer.component.html',
})
export class MediaViewerComponent implements OnInit {
	// Allow direct article input for modal usage
	@Input() title = '';
	@Input() mediaArticle?: Article;

	constructor(
		public activeModal: NgbActiveModal,

		private openAIService: OpenAIService,
		protected sourceMaterialService: SourceMaterialService,
	) {
		if (this.title === '' && this.mediaArticle) {
			this.title = this.mediaArticle.title;
		}
	}

	ngOnInit() {
		// this.mediaService.selectedMedia$.subscribe(media => {
		// this.media = media;
		// });
	}

	protected getAudioFile(): AudioArticle | undefined {
		const article: Article | undefined = this.mediaArticle;

		if (article && article.type == 'audio') {
			return article as AudioArticle;
		}

		return undefined;
	}

	protected getVideoFile(): VideoArticle | undefined {
		const article: Article | undefined = this.mediaArticle;

		if (article && article.type == 'video') {
			return article as VideoArticle;
		}

		return undefined;
	}

	protected getImageFile(): ImageArticle | undefined {
		const article: Article | undefined = this.mediaArticle;

		if (article && article.type == 'image') {
			return article as ImageArticle;
		}

		return undefined;
	}

	getVideoUrl(video: VideoArticle): string {
		return video.url;
	}

	getAudioUrl(audio: AudioArticle): string {
		switch (audio.sourceType) {
			case 'local':
				if (audio.localPath) {
					return `${encodeURIComponent(audio.localPath)}`;
				}
				return '';

			case 'url':
				if (audio.url) {
					return audio.url;
				}
				return '';
		}
	}

	getImageUrl(imageArticle: ImageArticle): Observable<string | undefined> {
		return this.sourceMaterialService.GetURLAsObject(imageArticle.id);
	}
}
